export var AuditLogAuthMethod;
(function (AuditLogAuthMethod) {
    AuditLogAuthMethod["LocalUser"] = "LOCAL_USER";
    AuditLogAuthMethod["Sso"] = "SSO";
})(AuditLogAuthMethod || (AuditLogAuthMethod = {}));
